import * as Sentry from "@sentry/nuxt";
import { beforeSend } from './sentry'

Sentry.init({
    dsn: "https://cab03012edf8f8547ddd95d518881a6d@o50847.ingest.us.sentry.io/4508678079905792",
    beforeSend,
});
